var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn_lg btn_cart btn_icontext",attrs:{"href":"/cart"}},[_c('i',{staticClass:"f7-icons icon_lg"},[_vm._v("cart")]),_c('span',[_vm._v(_vm._s(_vm.amount))]),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" р.")])])}
var staticRenderFns = []

export { render, staticRenderFns }